import React from 'react';
import { useLocation } from 'react-router-dom';
import { Video } from '../Components/Video';
import MainContent from '../Components/Global/MainContent';
import Footer from '../Components/Global/Footer';
import { Loader } from '../Components/Loader';
// import LogoQrR from '../img/logo-with-qr-background.png';
import Logo from '../img/logo.png';
import QR from '../img/qr-background.png';
import QRCode from 'react-qr-code';
import { useEffect, useState } from 'react';
import LogoQrR from '../img/logo-k-with-qr-background.png';
import { useRef } from 'react';

const Idle = ({ lobbyId, optionData, eventData, resetGame }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const screenType = queryParams.get('screen');
  const slideIndex = useRef(0);

  const screen1Spacer = 12 - Number(optionData?.acf?.screen_flex_position?.tv_1_spacer);
  const screen2Spacer = 12 - Number(optionData?.acf?.screen_flex_position?.tv_2_spacer);
  const screen3Spacer = 12 - Number(optionData?.acf?.screen_flex_position?.tv_3_spacer);
  const showVideo = !eventData?.acf?.disable_video_background;

  const [animClass, setAnimClass] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimClass((prevClass) => (prevClass % 4) + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      slideIndex.current = slideIndex.current === 0 ? 1 : 0;
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  if (!eventData || !eventData.acf) {
    return (
      <>
        {showVideo && <Video layer="bg" />}
        <MainContent>
          <div className="flex items-center justify-center w-full h-full relative grow">
            <Loader />
          </div>
          <Footer eventData={eventData} optionData={optionData} showLogo={true} />
        </MainContent>
        {showVideo && <Video layer="fg" />}
      </>
    );
  }

  return (
    <>
      {showVideo && <Video layer="bg" />}
      <MainContent>
        {showVideo && <div className="ani-artifact-glitch-1"></div>}
        <div className="flex items-center justify-center w-full h-full relative grow">
          {screenType === 'qr' && (
            <div className="grid grid-cols-12 w-full" dir="rtl">
              <div className={`order-last col-span-${screen3Spacer}`}>
                <div>
                  <div className="relative w-[28vw] mx-auto">
                    <img className="mx-auto h-auto relative z-10" src={QR} alt="QR Code" />
                    <div className="absolute z-20 w-full h-full top-0 left-0 flex justify-center flex-col items-center text-center text-dark">
                      <p className="container text-[3vw] leading-none font-bold py-[5%]">SCAN TO PLAY</p>
                      <figure className="w-[62%]">
                        <QRCode
                          className="relative w-full h-auto"
                          fgColor="#000"
                          value={`codecrackers-at-videri.kerve.com/${lobbyId}`}
                        />
                      </figure>

                      <p className="container text-[3vw] leading-none font-bold py-[5%]">HACK AND WIN</p>
                    </div>
                  </div>
                  {/* <div className={`mx-auto relative text-dark shrink-0`}>
                    <p className="">
                      <span className="text-[3cqw]">scan to play</span>
                    </p>
                    <figure className="w-[23%] aspect-square absolute right-[6.1%] top-[25.4%] block z-[2] flex items-center justify-center">
                    </figure>
                    <p className="w-[33%] right-[1%] bottom-[11.6%] uppercase font-bold absolute z-[2] text-center">
                      <span className="text-[3cqw]">hack and win</span>
                    </p>
                  </div> */}
                </div>
              </div>
            </div>
          )}

          {screenType === 'leaderboard' && (
            <div className="grid grid-cols-12 w-full">
              <div className={`col-span-${screen1Spacer}`}>
                <div className="container section flex flex-col gap-[3vw]">
                  <img className="mx-auto h-auto w-[20%]" src={Logo} alt="logo" />
                  <h2 className="text-h2 text-center font-extrabold !text-[6vw]">Leaderboard</h2>
                  <Leaderboard eventData={eventData} />
                </div>
              </div>
            </div>
          )}
          {screenType === 'extra' && (
            <div className="grid grid-cols-12 w-full">
              <div className={`col-span-${screen2Spacer}`}>
                <div className="container !max-w-[700px] section flex flex-col text-center space-y-[4vh]">
                  <h2 className="text-h2 font-extrabold !text-[10vw]">
                    How to <br />
                    play
                  </h2>
                  <figure className="max-w-[226px] w-full mx-auto">
                    <div className={`how-to-play-img anim-${animClass}`}></div>
                  </figure>
                  <ul className="space-y-2 text-[5vw] leading-[1.24]">
                    <li>1. Match the code.</li>
                    <li>2. Complete all three levels.</li>
                    <li>3. Make a mistake - start level again!</li>
                    <li>4. Fastest time wins.</li>
                  </ul>
                  {/* <p className="text-[5vw] mt-4 leading-[1.24]">Make a mistake and start the level again!</p> */}
                </div>
              </div>
            </div>
          )}
          {screenType === 'game' && eventData.acf.screen_layout_count === '4' && (
            <div className={`js-slide flex`}>
              <div className="container section flex flex-col justify-between space-y-40">
                <img className="mx-auto h-auto w-[34%]" src={Logo} alt="logo" />
                <div className="grow flex flex-col items-center justify-center">
                  <div className="space-y-14">
                    {eventData && eventData.acf.idle_screen_text && (
                      <p className="text-3xl text-center max-w-6xl mx-auto">{eventData.acf.idle_screen_text}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {screenType === 'game' && eventData.acf.screen_layout_count === '1' && (
            <div className="js-slide flex h-[90%] w-screen top-0 absolute py-14">
              <div className="container section flex flex-col  w-full justify-between py-10">
                {/* Intro Content at the Top */}
                <div>
                  <div className="flex items-center justify-center gap-[3vw]">
                    {/* LOGO */}
                    <img className="h-auto w-[38.8%]" src={Logo} alt="logo" />
                    {/* QR CODE */}
                    <div className="relative w-[20%]">
                      <img className="mx-auto h-auto relative z-10" src={QR} alt="QR Code" />
                      <div className="absolute z-20 w-full h-full top-0 left-0 flex justify-center flex-col items-center text-center text-dark">
                        <p className="text-[2vw] leading-none font-bold py-[5%]">SCAN TO PLAY</p>
                        <figure className="w-[66%]">
                          <QRCode
                            className="relative w-full h-auto"
                            fgColor="#000"
                            value={`codecrackers-at-videri.kerve.com/${lobbyId}`}
                          />
                        </figure>

                        <p className="text-[2vw] mx-0 leading-none font-bold py-[5%]">HACK AND WIN</p>
                      </div>
                    </div>
                  </div>
                  <div className="space-y-14">
                    {eventData?.acf?.idle_screen_text && (
                      <p className="text-[3.7vw] leading-none px-[10%] py-14 text-center mx-auto">
                        {eventData.acf.idle_screen_text}
                      </p>
                    )}
                  </div>
                </div>

                {/* Leaderboard in the Center */}
                {slideIndex.current === 1 && (
                  <div className="flex flex-col items-center justify-center flex-grow">
                    <div className="container section flex flex-col gap-[3vw]">
                      <h2 className="text-h2 text-center font-extrabold !text-[6vw]">Leaderboard</h2>
                      <Leaderboard eventData={eventData} />
                    </div>
                  </div>
                )}

                {slideIndex.current === 0 && (
                  <div className="w-full pb-[2vh]">
                    <div className="container w-full section flex flex-col text-center space-y-[3vh]">
                      <h2 className="text-h2 text-center font-extrabold !text-[6vw]">How to play</h2>
                      <figure className="max-w-[45%] w-full mx-auto py-10">
                        <div className={`how-to-play-img anim-${animClass}`}></div>
                      </figure>
                      <div className="space-y-2 text-[3.7vw] leading-[1.1] max-w-[15em] mx-auto">
                        <div
                          className="k-mce"
                          dangerouslySetInnerHTML={{
                            __html: eventData.acf.how_to_copy,
                          }}
                        ></div>
                      </div>
                      {/* <p className="text-[5vw] mt-4 leading-[1.24]">Make a mistake and start the level again!</p> */}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        {screenType === 'game' && (
          <Footer eventData={eventData} showLogo={true} optionData={optionData} resetGame={resetGame} />
        )}
      </MainContent>
      {showVideo && <Video layer="fg" />}
    </>
  );
};

// const LogoQR = ({ width, height, textSize = 'text-base', lobbyId }) => {
//   return (
//     <div className={`${width} ${height} mx-auto relative text-dark shrink-0`}>
//       <img className="w-full h-auto absolute left-0 top-0 z-[1]" src={Logo} alt="logo" />
//       <p className="w-[33%] right-[1%] top-[12%] uppercase font-bold absolute z-[2] text-center">
//         <span className={textSize}>scan to play</span>
//       </p>
//       <figure className="w-[23%] aspect-square absolute right-[6.1%] top-[25.4%] block z-[2] flex items-center justify-center">
//         <QRCode className="absolute w-full h-full inset-0" value={`codecrackers-at-videri.kerve.com/${lobbyId}`} />
//       </figure>
//       <p className="w-[33%] right-[1%] bottom-[11.6%] uppercase font-bold absolute z-[2] text-center">
//         <span className={textSize}>hack and win</span>
//       </p>
//     </div>
//   );
// };

const Leaderboard = ({ eventData }) => {
  const scoreboard = eventData.acf.scoreboard || [];
  const sortedScores = scoreboard
    .filter(({ score }) => score < 120000) // More concise destructuring
    .sort((a, b) => a.score - b.score) // Correct ascending sort
    .slice(0, 10); // Takes the top 10 lowest scores

  function getTime(time) {
    const date = new Date(+time);
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const milliseconds = String(Math.round(date.getMilliseconds() / 10)).padStart(2, '0'); // Rounds to 2 digits

    return `${minutes}:${seconds}:${milliseconds}`;
  }

  return (
    <div className="h-auto flex justify-center">
      <div className="mt-6 w-full flex flex-col mx-auto divide-y divide-mid bg-black rounded-lg drop-shadow-white-md">
        {sortedScores.map((item, index) => (
          <div key={index} className="text-[2.4vw] w-full grid grid-cols-12 flex-row justify-between">
            <span className="px-5 py-[6px] font-bold col-span-5 flex items-center">
              <span className="w-[24px] mr-4">{index + 1}</span>
              <span className="whitespace-nowrap text-ellipsis overflow-hidden">{item?.player[0]?.acf?.name}</span>
            </span>
            <span className="px-5 py-[6px] col-span-4 whitespace-nowrap text-ellipsis overflow-hidden">
              {item?.player[0]?.acf?.company}
            </span>
            <span className="px-10 py-[6px] text-right font-bold col-span-3">{getTime(item?.score)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export const LogoQR = ({ textSize = 'text-base', lobbyId }) => {
  return (
    <div className="w-[40%] h-auto mx-auto relative text-dark shrink-0">
      <img className="w-full h-auto absolute left-0 top-0 z-[1]" src={LogoQrR} alt="logo with QR code" />
      <div className="w-[33%] right-[1%] pt-4 xl:pt-10 items-center uppercase font-bold absolute z-[2] text-center flex flex-col justify-center">
        <p className="">
          <span className={'text-[1.5vw]'}>scan to play</span>
        </p>
        <figure className="js-qr-container w-[80%] aspect-square block z-[2] flex items-center justify-center">
          <QRCode className="w-full h-full inset-0" value={`https://codecrackers-at-videri.kerve.com/${lobbyId}`} />
        </figure>
        <p className="">
          <span className={'text-[1.5vw]'}>hack and win</span>
        </p>
      </div>
    </div>
  );
};

export default Idle;
